export default __webpack_public_path__ + "static/media/file.0d58af63.png";